<template>
  <div class="public-cp-registration-page">
    <iframe
      :src="registrationFormUrl"
      class="registration-form-iframe"
      title="Company Associate Partner Registration"
      frameborder="0"
      allow="clipboard-write"
      loading="lazy"
    />
  </div>
</template>

<script>
export default {
  name: "PublicCpRegistrationForm",
  computed: {
    registrationFormUrl() {
      const api = (process.env.VUE_APP_CP_REGISTRATION_API_URL || "https://api.erp.nestoriagroup.com")
        .replace(/\/$/, "");
      const uuid = this.$route.params.uuid;
      return `${api}/cp-registration-form/${uuid}`;
    },
  },
};
</script>

<style scoped>
.public-cp-registration-page {
  width: 100%;
  min-height: 100vh;
  margin: 0;
  padding: 0;
  background: #0f172a;
}

.registration-form-iframe {
  display: block;
  width: 100%;
  min-height: 100vh;
  height: 100vh;
  border: 0;
}
</style>
